import React, { useState } from 'react';
import {
    useRecordContext,
    useCreate,
    Confirm,
    useNotify,
    useRedirect
} from 'react-admin';

import SendIcon from '@mui/icons-material/Send';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import { sendButtonCss } from '../shared/Styles/buttonStyles';

export const ConfirmDialogSendButtonCustom = ({ email, titolo, messaggio, servizio, redirectPath }) => {
    const record = useRecordContext();
    const [open, setOpen] = useState(false);
    const notify = useNotify();
    const redirect = useRedirect();

    const [create, { isLoading }] = useCreate();

    const handleClick = () => setOpen(true);
    const handleDialogClose = () => setOpen(false);
    const handleConfirm = () => {

        const newRecord = {
            "tblQuizId": record.id,
            "usersId": record.usersId,
            "email": email,
            "status": "INIT"
        };

        create(servizio, { data: newRecord }, {
            onSuccess: ({ data }) => {
                notify('Tentativo di inoltro creato con successo', 'info');
                // window.location.reload();  // Esegue il refresh della pagina
            },
            onFailure: (error) => {
                notify(`Errore: ${error.message}`, 'warning');
            }
        });
        setOpen(false);
    };

    return (
        <>
            {isLoading ? (
                <CircularProgress size={24} sx={{ color: '#e85a2c' }} />
            ) : (
                <Button
                    sx={sendButtonCss}
                    onClick={handleClick}
                    variant="contained"
                    size="small"
                    endIcon={<SendIcon />}
                    component="label"
                    color="primary"
                >
                    INVIA MESSAGGIO AL CANDIDATO
                </Button>
            )}
            <Confirm
                isOpen={open}
                loading={isLoading}
                title={titolo || "Crea record"}
                content={messaggio}
                onConfirm={handleConfirm}
                onClose={handleDialogClose}
                confirm="Si"
                cancel="No"
            />
        </>
    );
};
